import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { siteSpecificData } from '@environments/site-specific-data';
import { IContext } from '@context/models/context';
import { ContactUsModel } from '../models/contactus-model';
import { HttpParams } from '@angular/common/http';
import { IManagementType } from '@common/models/management-type';

const API_URL = siteSpecificData.apiUrlBase;

@Injectable()
export class ContactUsHttpService {

  constructor(
    private readonly http: HttpClient
  ) { }

  getContactUs(context: IContext): Observable<ContactUsModel[]> {

    let httpParams = new HttpParams();
    if (context.UserEnteredClientRef !== undefined) { httpParams = httpParams.append('UserEnteredClientRef', String(context.UserEnteredClientRef)); }
    if (context.UnitRef !== undefined) { httpParams = httpParams.append('UnitRef', String(context.UnitRef)); }
    if (context.PropertyRef !== undefined) { httpParams = httpParams.append('PropertyRef', String(context.PropertyRef)); }
    if (context.EstateRef !== undefined) { httpParams = httpParams.append('EstateRef', String(context.EstateRef)); }
    const managerInfoUrl = `${API_URL}managers`;
    return this.http
      .get<ContactUsModel[]>(managerInfoUrl, { params: httpParams }).pipe(
        map(overview => overview || undefined)
      );
  }

  getManagementTypes(): Observable<IManagementType[]> {
    const managerTypeUrl = `${API_URL}managers/types`;
    return this.http
      .get<IManagementType[]>(managerTypeUrl).pipe(
        map(managerTypes => managerTypes || undefined)
      );
  }

  imageExists(code: string): Observable<boolean> {
    const url = `${API_URL}managers/image/${code}/exists`;
    return this.http.get<boolean>(url);
  }



}
